// The learner count as the server prints it everywhere else ("48,000+"),
// handed to the page through gon (see app/views/application/_gon.html.slim
// and PageHelper#learner_count_display) so the places that say it in React
// agree with the meta tags and the structured data. The fallback is only
// seen where gon is absent, such as a unit test.
export const LEARNER_COUNT_FALLBACK = "48,000+";

export const learnerCountDisplay = (): string => {
  const gon = (window as any)?.gon;
  return (gon && gon.learner_count_display) || LEARNER_COUNT_FALLBACK;
};
